import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "notificationFont" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "notificationFont" }
const _hoisted_7 = { key: 1 }

import { reactive, onUpdated, onMounted, onUnmounted, watch } from "vue";
import { useRouter } from 'vue-router';
import IconNotifAction from "../../components/icons/IconNotifAction.vue" // eslint-disable-line no-unused-vars
import IconNotifSurvey from "../../components/icons/IconNotifSurvey.vue" // eslint-disable-line no-unused-vars
import IconNotifCelebration from "../../components/icons/IconNotifCelebration.vue" // eslint-disable-line no-unused-vars
import { appStatus } from '../../use/useAppStatus';   
import { useLocalNotificatiSync } from '../../use/useLocalNotificatiSync';


/*
  declarations
*/

export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBar',
  setup(__props) {



const router = useRouter();

var iconsStatus = reactive({
  icon: "",
  textCollapsed: "",
  textExpanded: ""
});

let notificationCheckInterval: ReturnType<typeof setInterval> | null = null;

onUpdated(() => {
    console.log("NotificationBar.vue onUpdated");
});

const refreshNotificationBar = () => {
    var notifData = localStorage.getItem("notificationData");
    if (notifData != null && notifData.length > 0 && notifData != '[]') {
        const unseenNotifications = JSON.parse(notifData).filter((notification: any) => !notification.viewed && Date.now() > notification.time);
        if (unseenNotifications.length > 0) {
            const latestNotification = unseenNotifications[unseenNotifications.length - 1];
            iconsStatus.icon = latestNotification.icon;
            iconsStatus.textCollapsed = latestNotification.textCollapsed;
            iconsStatus.textExpanded = latestNotification.textExpanded;
            appStatus.displayInAppsNotification = true;
        } else {
            appStatus.displayInAppsNotification = false;
        }
    }
}

onMounted(() => {

    // check notifications every 60 seconds
    notificationCheckInterval = setInterval(refreshNotificationBar, 60000);

    // refresh notification bar when localStorage is updated, 
    // for example when user click on notification in the notification center
    const handleStorageEvent = (event: StorageEvent) => {
        if (event.key === 'notificationData') {
            console.log("NotificationBar.vue storage event");
            refreshNotificationBar();
        }
    };
    window.addEventListener('storage', handleStorageEvent);
    onUnmounted(() => {
        window.removeEventListener('storage', handleStorageEvent);
        if (notificationCheckInterval !== null) {
            clearInterval(notificationCheckInterval);
        }
    });

    // refresh notification bar when component is mounted
    refreshNotificationBar();
});

// using watch to update the notification bar when notification is trigger on same route
watch(appStatus.notificationList, () => {
    console.log("NotificationBar.vue watch");
    refreshNotificationBar();
});

function openNotificationPage() {

    //[todo] need to update the notification data to display false, so that the notification will not be display again. need to handle older notification is true but latest is false issue
    var notifData = localStorage.getItem("notificationData");
    if(notifData != null){
        var parsedata = JSON.parse(notifData) 
        parsedata[parsedata.length-1].viewed = true; 
        parsedata[parsedata.length-1].display = true;
        useLocalNotificatiSync().UpdateInAppNotifViewedStatus(parsedata[parsedata.length-1].back_end_id);
        localStorage.setItem("notificationData", JSON.stringify(parsedata));
    }

    appStatus.displayInAppsNotification = false; 
    router.push({name: 'notifications'});
}

async function openAdHocQuestionPage() {

    let adHocShow = false;
    const notifData = localStorage.getItem("notificationData");
    if (notifData !== null) {
        for (let i = 0; i < JSON.parse(notifData).length; i++) {
        if (JSON.parse(notifData)[i].type === "adHoc") {
            console.log("adHocStorage");
            adHocShow = true;
            break;
        }
        }

        if(!adHocShow){
            var parsedata = JSON.parse(notifData) 
            parsedata[parsedata.length-1].viewed = true; 
            parsedata[parsedata.length-1].display = true;
            // update in-app notification viewed status to database
            useLocalNotificatiSync().UpdateInAppNotifViewedStatus(parsedata[parsedata.length-1].back_end_id);
            localStorage.setItem("notificationData", JSON.stringify(parsedata));
        }
    }

    appStatus.displayInAppsNotification = false; 
    router.push({name: 'notifications'});
}

//[todo] push notification work in progress
//[todo] if trigger InAppsNotification subscription will be replace and we need to update the subscription to server again. more testing needed!
/* eslint-disable */
function triggerInAppsNotification() {
    if ('PushManager' in window) {
        const options = {
            body: 'Your notification message',
            icon: 'img/icons/apple-touch-icon-60x60.png', 
            image: 'img/icons/apple-touch-icon-120x120.png', 
        };

        navigator.serviceWorker.ready.then(registration => {

            registration.pushManager.getSubscription().then(subscription => {
                console.log(JSON.stringify(subscription));
            if (subscription) {
                // Send a push message
                registration.showNotification('TouchPoints', options);
                
            } else {
                // User is not subscribed to push notifications
                console.log('User is not subscribed');
            }
            });
        });
    }
}
/* eslint-enable */


return (_ctx: any,_cache: any) => {
  return (_unref(iconsStatus).icon === 'survey')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(appStatus).displayInAppsNotification)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "notificationBarWrapper",
              onClick: _cache[0] || (_cache[0] = () => openAdHocQuestionPage())
            }, [
              _createVNode(IconNotifSurvey),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(iconsStatus).textCollapsed), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_unref(appStatus).displayInAppsNotification)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "notificationBarWrapper",
              onClick: _cache[1] || (_cache[1] = () => openNotificationPage())
            }, [
              (_unref(iconsStatus).icon === 'action')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(IconNotifAction)
                  ]))
                : _createCommentVNode("", true),
              (_unref(iconsStatus).icon === 'celebration')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(IconNotifCelebration)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(iconsStatus).textCollapsed), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7))
      ]))
}
}

})